import { AsyncPipe } from '@angular/common';

import { RouterModule } from '@angular/router';

export const appDependencies = [
    AsyncPipe,
    RouterModule
];

